import React, {FC} from "react";
import {useProfileData} from "../../resources/ProfileContext";

export const ProfilePage: FC<{ }> = (props) => {
  const { profile } = useProfileData()
  console.log(profile)
  return <main>
    {profile ? <div className={'flex bg-brand-secondary-container rounded-sm px-4 py-3 gap-4'}>

      {/*Profile picture*/}
      <div className={'flex h-40 w-40 border border-black rounded-sm items-center justify-center hover:cursor-pointer'}>
        <img src={profile.profile_picture ?? "https://blog.cogitactive.com/wp-content/uploads/sites/2/2019/12/Mystery-Man-300x300.png"} alt={""} className={""} />
      </div>

      {/*Information*/}
      <div className={'flex flex-col gap-4'}>
        <div>
          <div>Naam:</div>
          <div>{profile.firstName} {profile.lastName}</div>
        </div>

        <div>
          <div>Email:</div>
          <div>{profile.emailAddress}</div>
        </div>
      </div>

    </div> : <div>

    </div>}
  </main>
}